import React, { Fragment } from 'react'; 
import { NavLink } from 'react-router-dom';

const ErrorSoonPage = () => {
    return (
        <Fragment>
            <div className="container-fluid px-lg-1 px-xl-3">
                <div className="page-breadcrumb">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <NavLink to="/Inicio">Principal</NavLink>
                        </li>
                        <li className="breadcrumb-item">
                            <NavLink to="/Inicio">Próximamente</NavLink>
                        </li>
                    </ul>
                </div>
                <div className="page-header">
                    <h1 className="page-heading">Próximamente</h1>
                </div>
                <section>
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="text-center py-5">
                                <div className="mb-4">
                                    <i className="fas fa-rocket fa-4x text-primary animate-pulse"></i>
                                </div>
                                <h2 className="display-4 mb-3">¡Estamos trabajando en ello!</h2>
                                <div className="row justify-content-center">
                                    <div className="col-md-8 col-lg-6">
                                        <p className="lead text-muted mb-4">
                                            Esta funcionalidad estará disponible en las próximas iteraciones. 
                                            Estamos trabajando para brindarte la mejor experiencia posible.
                                        </p>
                                        <div className="card bg-light border-0 p-4 mb-4">
                                            <h3 className="h5 mb-3">¿Qué puedes esperar?</h3>
                                            <ul className="list-unstyled text-muted mb-0">
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success me-2"></i>
                                                    Nuevas características
                                                </li>
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success me-2"></i>
                                                    Mejoras en la experiencia de usuario
                                                </li>
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success me-2"></i>
                                                    Optimizaciones de rendimiento
                                                </li>
                                            </ul>
                                        </div>
                                        <NavLink 
                                            to="/Inicio" 
                                            className="btn btn-primary btn-lg"
                                        >
                                            Volver al Inicio
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                        
                </section>
            </div>
        </Fragment>
    );
}

export default ErrorSoonPage;
